import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AdditionalfeesService {

  constructor(private http: HttpClient) { }

  getAllGroups() {
    return this.http.get<any>(`${environment.timeZoneURL}Group`);
  }

  getAllDiscountTypes(groupId) {
    return this.http.get<any>(`${environment.inventoryURl}Type?groupId=${groupId}`);
  }
  getAdditionalfeesList(typeId){
    return this.http.get<any>(`${environment.inventoryURl}Discount/GetAllAdditionalFees?typeId=${typeId}`)
  }
}
